import React from 'react';
import { Star } from './Star';
import { AllowedScores } from '../module/module';
import { Label } from 'workspace-core-ui';

export const Score = ({
    variant = 'end',
    points
}: {
    variant?: 'history' | 'end',
    points: AllowedScores | null
}): JSX.Element => {
    const levels = [
        { star: 1, percentage: '60%' },
        { star: 2, percentage: '80%' },
        { star: 3, percentage: '100%' }
    ];

    let gap;
    let margin;
    let showScorePercentage = false;
    switch (variant) {
        case 'end':
            gap = '25px';
            margin = '20px 0';
            showScorePercentage = true;
            break;
        case 'history':
        default:
            gap = '10px';
            margin = '1px 0';
            break;
    }

    return ((showScorePercentage ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin, gap }}>
            {levels.map((level, index) => (
                <div key={level.star} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Star variant={points == null ? "default" : variant} isFull={points !== null && index < points} />
                    <Label variant="readMore" style={{ marginTop: '8px' }}>{points !== null ? level.percentage : '0%'}</Label>
                </div>
            ))}
        </div>
    ) : (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin, gap }}>
        {levels.map((level, index) => (
            <Star key={level.star} variant={points == null ? "default" : variant} isFull={points !== null && index < points} />
        ))}
    </div>)));
};